import { render, staticRenderFns } from "./StocksTable.vue?vue&type=template&id=a2eefb66&scoped=true&"
import script from "./StocksTable.vue?vue&type=script&lang=js&"
export * from "./StocksTable.vue?vue&type=script&lang=js&"
import style0 from "./StocksTable.vue?vue&type=style&index=0&id=a2eefb66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2eefb66",
  null
  
)

export default component.exports